// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#serviceStatusStrip.text-caption[data-v-23eb929b] {\n  letter-spacing: normal !important;\n}\n.highlight-auto[data-v-23eb929b] {\n  color: #4998c8;\n  text-decoration: underline;\n}\n.v-tooltip__content[data-v-23eb929b] {\n  pointer-events: initial;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
